import { CvsFilePicker } from '@components'
import { css } from '@emotion/react'
import { t } from '@lingui/core/macro'
import { func, object } from 'prop-types'

const paddingY = css`
  padding-top: 8px;
  padding-bottom: 8px;
`

export const GoogleDV360 = ({ setUpdatedAccount }) => {
  return (
    <div>
      <span>{t`This file can be generated in your google cloud account at`}</span>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://console.cloud.google.com/apis/credentials/serviceaccountkey"
      >
        https://console.cloud.google.com/apis/credentials/serviceaccountkey
      </a>
      <div css={paddingY}>
        <CvsFilePicker
          onChange={file =>
            setUpdatedAccount(old => ({
              ...old,
              metadata: { ...old.metadata, account_key_file: JSON.parse(file) },
            }))
          }
          fileType=".json"
          fullWidth
        />
      </div>
    </div>
  )
}

GoogleDV360.propTypes = {
  updatedAccount: object.isRequired,
  setUpdatedAccount: func.isRequired,
}
